import { useEffect, useState } from 'react'
import _ from 'lodash'
import Footer from '../../components/Footer'
import Header from '../../components/Header'
import PageTitleCS from '../../components/PageTitleCS'
import Card from '../../components/Card'
import CustomerSupportSiteApplication from '../CustomerSupportSiteApplication'
import { CUSTOMER_SUPPORT } from '../../components/Header/constants'
import Loader from '../../utils/loader'
import { getIsInstaller, getSessionToken } from '../../utils/helper'
import history from '../../routes/history'
import { useStyles } from './styles'
const CustomerSupportHomePage = () => {
  const [loading, setLoading] = useState(false)
  const [selected, setSelected] = useState(false)
  const classes = useStyles()
  useEffect(() => {
    if (_.isEmpty(getSessionToken())) history.push('/')
    else if (
      _.isEmpty(getIsInstaller()) === false &&
      getIsInstaller() === 'true'
    )
      history.push('/installer')
  }, [])
  return (
    <>
      <Loader loading={loading} />
      <Header
        isSignedIn={true}
        role={CUSTOMER_SUPPORT}
        setLoading={setLoading}
        selected={selected}
        setSelected={setSelected}
      ></Header>
      <PageTitleCS></PageTitleCS>
      <Card
        className={classes.cardWrapper}
        children={
          <CustomerSupportSiteApplication
            setLoading={setLoading}
          ></CustomerSupportSiteApplication>
        }
      />
      <Footer></Footer>
    </>
  )
}
export default CustomerSupportHomePage
